import { EOAListItem } from '../../interfaces/UserDetailsInterface';
import { configurationPath, configurationStepPath, firstConfigurationStepId } from './eoaConfigurationPaths';

const PENDING_EOA_STATUS = 'PENDING';

const isPendingConfigurationEoa = (eoa: EOAListItem): boolean => eoa.status === PENDING_EOA_STATUS;

const formatConfigurationEoaLabel = (eoa: EOAListItem): string => {
  const districtName = eoa.district.name?.trim() || 'Untitled district';
  if (!eoa.year_ending) return districtName;
  return `${districtName} (${eoa.year_ending - 1}-${eoa.year_ending})`;
};

const configurationLandingItems = (eoas: EOAListItem[]) =>
  eoas.filter(isPendingConfigurationEoa).map((eoa) => ({
    label: formatConfigurationEoaLabel(eoa),
    value: eoa.id,
  }));

const createNewConfigurationPath = configurationStepPath(firstConfigurationStepId);

const continueConfigurationPath = (eoaId: string): string => configurationPath(eoaId, firstConfigurationStepId);

export {
  configurationLandingItems,
  continueConfigurationPath,
  createNewConfigurationPath,
  formatConfigurationEoaLabel,
  isPendingConfigurationEoa,
};
